export const config = {
  title: "eXp Realty | Thao Han - Irving, TX",
  meta: {
    description:
      "Thao Han with eXp Realty provides trusted real estate services in Irving, TX. Specializing in buying, selling, and investing in residential and commercial properties.",
    keywords: [
      "eXp Realty",
      "Thao Han Realtor",
      "Real Estate Irving TX",
      "Buy a Home Irving",
      "Sell a Home Irving",
      "Texas Realtor",
    ],
    author: "eXp Realty - Thao Han",
    canonicalUrl: "https://www.thaohanexprealty.com/thao-han/",
  },
  sections: {
    header: {
      businessName: "eXp Realty - Thao Han",
    },
    sectionB: {
      heroTitle: "Find Your Dream Home with eXp Realty",
      heroSubtitle: "Trusted Real Estate Services in Irving, TX",
      learnAboutText: "Explore Properties",
      phoneNumber: "4698863966",
      phoneLabel: "(469) 886-3966",
      heroBackgroundImage:
        "https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      cardData: [
        {
          title: "Buying a Home",
          description:
            "Explore a wide selection of residential properties in Irving and beyond with expert guidance.",
        },
        {
          title: "Selling a Home",
          description:
            "Get maximum value for your property with proven marketing and negotiation strategies.",
        },
        {
          title: "Investment Properties",
          description:
            "Discover smart real estate investment opportunities across Texas with personalized advice.",
        },
      ],
      description:
        "At eXp Realty, Thao Han provides dedicated real estate services, helping clients buy, sell, and invest in properties across Irving, TX and surrounding areas.",
    },
    sectionC: {
      servicesTitle: "Our Real Estate Services",
      servicesDescription:
        "We specialize in buying, selling, and investing in both residential and commercial real estate throughout Texas.",
      cards: [
        {
          title: "Residential Sales",
          description:
            "Helping families find the perfect home tailored to their lifestyle and budget.",
          imageSrc: "https://media.istockphoto.com/id/2170456340/photo/neighborhood-new-homes-sunset-north-carolina-wide-angle.jpg?s=612x612&w=0&k=20&c=UYZc4IywEHt_dabvvf3DD19mCA_1TdjoSMw58lm1rG4=",
          imageAlt: "Residential Home",
        },
        {
          title: "Commercial Real Estate",
          description:
            "Expert guidance in buying and selling commercial spaces for your business.",
          imageSrc: "https://media.istockphoto.com/id/1351571961/photo/looking-directly-up-at-the-skyline-of-the-financial-district-in-central-london.jpg?s=612x612&w=0&k=20&c=4J_aWJc5gMATCtIbMkF0dMq4dzz_XjLx5DpwnuPJwkg=",
          imageAlt: "Commercial Property",
        },
        {
          title: "Property Investments",
          description:
            "Explore profitable property investments in growing Texas markets.",
          imageSrc: "https://media.istockphoto.com/id/1484779739/photo/real-estate-agents-recommend-interest-rates-discuss-the-terms-of-the-home-purchase-agreement.jpg?s=612x612&w=0&k=20&c=CON2qfAss2pApUZymNjkFQMlwdAEx2I5QW_qT5V8EpQ=",
          imageAlt: "Investment Properties",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Home Valuation",
        "Relocation Assistance",
        "Market Analysis",
        "Virtual Tours",
        "First-Time Buyer Guidance",
      ],
    },
    sectionD: {
      aboutTitle: "About Thao Han - eXp Realty",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2174673536/photo/city-of-london-corporate-office-buildings-vertical-perspective.jpg?s=612x612&w=0&k=20&c=h1Dy6_USbSMJVCcrGuqTZxpIJOABMKsrWwJWGX_uuPw=",
        alt: "Realtor Thao Han",
      },
      aboutText: [
        "Thao Han is a trusted Realtor® with eXp Realty, dedicated to helping clients achieve their real estate goals in Irving, TX and surrounding areas.",
        "Whether you are buying your first home, selling your property, or investing in real estate, Thao provides expert guidance, market insights, and exceptional service.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "eXp Realty Logo",
      businessName: "eXp Realty - Thao Han",
      contact: {
        phone: "4698863966",
        phoneLabel: "(469) 886-3966",
        email: "thao.han@exprealty.com",
        website: "https://www.thaohanexprealty.com/thao-han/",
        address: "5605 N. MacArthur Blvd, Irving, TX 75038",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "5605 N. MacArthur Blvd, Irving, TX 75038",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3356.692408034509!2d-96.9565638!3d32.8799079!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e829f2b51d2cf%3A0xd4794e1d7e6ef2fa!2s5605%20N%20MacArthur%20Blvd%2C%20Irving%2C%20TX%2075038!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;
